import * as React from "react";

function BenefitDot() {
  return (
    <div 
      role="presentation" 
      aria-hidden="true" 
      className="tw-hidden md:tw-flex tw-shrink-0 tw-self-stretch tw-my-auto tw-w-3 tw-h-3 tw-rounded-full tw-bg-white tw-bg-opacity-30 tw-fill-white" 
    />
  );
}

function BenefitItem({ text }) {
  return (
    <div 
      role="listitem"
      className="tw-self-stretch tw-my-auto tw-md:max-w-full md:tw-text-6xl tw-whitespace-nowrap"
    >
      {text}
    </div>
  );
}

export function RevenueBenefits() {
  const BENEFITS = [
    "Increase Revenue",
    "Extend Sales Lifespan", 
    "Tax Benefits",
    "Strengthen Brand",
    "Minimize Impact"
  ];

  return (
    <section 
      aria-label="Revenue Benefits"
      className="scrolling-container tw-font-inter tw-font-normal tw-flex tw-justify-center tw-px-16 tw-py-24 tw-mt-32 tw-w-full tw-leading-tight tw-text-white tw-bg-neutral-700 tw-md:pl-5 tw-md:mt-10 tw-md:max-w-full tw-md:text-4xl"
      style={{background: '#364740'}}
    >
      <div 
        role="list"
        className="scrolling-content tw-flex tw-gap-8 tw-items-center tw-text-5xl tw-md:text-4xl"
      >
        {[...Array(5)].map((_) => (
          BENEFITS.map((benefit, index) => (
            <React.Fragment key={benefit}>
              <BenefitItem text={benefit} />
              {index < BENEFITS.length - 1 && <BenefitDot />}
            </React.Fragment>
          ))
        ))}
      </div>
    </section>
  );
}
